import Header from '@components/shared/Header/Header';
import { AssetLinks } from '@assets/assets';
import { useTexts } from 'utils/useTexts';
import useEffectOnce from '@shared/hooks/useEffectOnce';
import { useAnalytics } from '@shared/hooks/useAnalytics';
import { useAnalyticsContext } from '@context/analyticsContext';

const Error = () => {
  const { t } = useTexts();
  const {analyticsState} = useAnalyticsContext();
  const { trackClick, trackPage } = useAnalytics({
    flow_step :analyticsState?.parameters?.flow_step,
    flow_stage: analyticsState?.parameters?.flow_stage,
  });

  const containerClass =
    process.env.REACT_APP_IS_WIDGET === 'true' ? 'iLendingCDX__widget-container' : 'iLendingCDX__spa-container';
  useEffectOnce(() => trackPage(t('pageTitles.Error')));

  const handlePhoneNumberClick = () => {
    trackClick('CTA Clicked', {
      cta_text: 'Call'+t('contactPhoneNumber'),
      cta_type: 'phone',
      cta_context: 'off-ramp',
      interaction_type: 'cta_click',
      destination_url: 'tel:'+t('contactPhoneNumber'),
      value: 75,
      currency: 'USD',
    });
  };

  return (
    <div className={containerClass}>
      <Header />
      <div className="iLendingCDX-widget-form">
        <div className="iLendingCDX-error">
          <img
            src={AssetLinks.brokenCar}
            alt=""
          />
          <h1> {t('error.title')}</h1>
          <p>
            {t('error.startText')}{' '}
            <a
              href={'tel:' + t('contactPhoneNumber').replace(/-/g, '')}
              onClick={handlePhoneNumberClick}
            >
              {t('contactPhoneNumber')}
            </a>
          </p>

          <p>{t('error.endText')}</p>
        </div>
      </div>
    </div>
  );
};

export default Error;
